<template>
  <!-- <div class="modal" v-if="isshow"> -->

  <div class="keyboard" :class="isIosX?'pd-34':''">
    <div v-for="(item, index) of list" :key="index" class="keyboard-item" @touchstart="handleTouchStart(index)" @touchend="handleTouchEnd(item)">
      <img v-if="item == 'del'" :src="paydelete" class="keyboard-delete" />
      <span v-else-if="item == '取消'" @click="cancel(item,index)" class="keyboard-cancel">{{item}}</span>
      <span v-else>{{item}}</span>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: '请输入支付密码'
      },
      tips: {
        type: String,
        default: ''
      },
      tipsColor: {
        type: String,
        default: 'color: rgba(0, 0, 0, 0.3);'
      },
      maxLength: {
        type: Number,
        default: null,
      }
    },
    data () {
      return {
        current: null,
        list: [1, 2, 3, 4, 5, 6, 7, 8, 9, '.', 0, 'del'],
        pwd: '',
        paydelete: require("@/assets/groupRob/pay-delete.png"),
        isIosX: false,
      };
    },
    created () {
      this.isIosX = this.isIphoneX()
      this.pwd = ''
    },
    methods: {
      handleTouchStart (e) {
        this.current = e;
      },
      handleTouchEnd (e) {
        this.current = null;
        if (e == '取消') {
          return this.cancel()
        }
        if (e == 'del') {
          this.pwd = this.pwd.slice(0, -1);
        } else {
          if (this.pwd.includes('.') && (e.toString() == "." || this.pwd.split('.')[1].length == 2)) {
            return
          }
          if (this.pwd.length < this.maxLength && this.maxLength) {
            this.pwd = this.pwd + e.toString()
          }
        }
        this.$emit('inpiut', this.pwd);
      },
      cancel (item, index) {
        this.$emit('close', { value: item, index });
      },
      submit () {
        this.$emit('submit', this.pwd);
      }
    }
  }
</script>

<style lang="less" scoped>
  .keyboard {
    width: 100%;
    height: 212px;
    background-color: transparent;
    padding: 12px 0 0 12px;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;

    .keyboard-item {
      flex: 0 0 30%;
      background-color: #FFFFFF;
      box-sizing: border-box;
      border-radius: 4px;
      margin-right: 8px;
      margin-bottom: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: rgba(0, 0, 0, 1);
      font-size: 22px;
      height: 47px;
      line-height: 47px;
      font-weight: bold;

      &.active {
        background-color: rgba(0, 0, 0, 0.1);
      }

      .keyboard-delete {
        width: 20px;
        height: 20px;
      }

      .keyboard-cancel {
        font-size: 14px;
        font-weight: normal;
        line-height: 20px;
      }
    }
  }
</style>